var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbledLogoH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 396.47 241.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-22 {\n        fill: #585b5c;\n      }\n\n      .cls-23 {\n        fill: #19181c;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 90.22,
    y1: 90.05,
    x2: 107.15,
    y2: 90.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#882935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a42631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bd242d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d2232a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e02128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e82127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb2127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10751.18,
    y1: 206.19,
    x2: 10768.12,
    y2: 206.19,
    gradientTransform: "translate(367.23 -10601.77) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 10867.32,
    y1: -10454.78,
    x2: 10884.26,
    y2: -10454.78,
    gradientTransform: "translate(10969 -10234.54) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 206.36,
    y1: -10570.92,
    x2: 223.29,
    y2: -10570.92,
    gradientTransform: "translate(10601.77 367.23) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5396.77,
    y1: 2356.17,
    x2: 5413.71,
    y2: 2356.17,
    gradientTransform: "translate(-2012.08 -5377.05) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 13017.41,
    y1: -5100.21,
    x2: 13034.35,
    y2: -5100.21,
    gradientTransform: "translate(5744.28 -12613.85) rotate(135)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5561.02,
    y1: -12720.85,
    x2: 5577.96,
    y2: -12720.85,
    gradientTransform: "translate(12981.08 -4857.49) rotate(-135)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2059.62,
    y1: -5264.46,
    x2: -2042.68,
    y2: -5264.46,
    gradientTransform: "translate(5224.72 2379.31) rotate(-45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 8324.52,
    y1: 1799.22,
    x2: 8341.46,
    y2: 1799.22,
    gradientTransform: "translate(-1326.07 -8261.53) rotate(67.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 12461.18,
    y1: -8027.66,
    x2: 12478.12,
    y2: -8027.66,
    gradientTransform: "translate(8628.77 -11927.84) rotate(157.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2634.3,
    y1: -12164.31,
    x2: 2651.24,
    y2: -12164.31,
    gradientTransform: "translate(12295.07 -1973) rotate(-112.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1502.35,
    y1: -2337.44,
    x2: -1485.42,
    y2: -2337.44,
    gradientTransform: "translate(2340.24 1693.3) rotate(-22.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 12395.51,
    y1: -2186.13,
    x2: 12412.44,
    y2: -2186.13,
    gradientTransform: "translate(2818.51 -12128.7) rotate(112.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 8474.65,
    y1: -12100.03,
    x2: 8491.59,
    y2: -12100.03,
    gradientTransform: "translate(12495.93 -7783.26) rotate(-157.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1439.24,
    y1: -8179.17,
    x2: -1422.31,
    y2: -8179.17,
    gradientTransform: "translate(8150.49 1894.17) rotate(-67.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2481.61,
    y1: 1734.72,
    x2: 2498.55,
    y2: 1734.72,
    gradientTransform: "translate(-1526.93 -2451.28) rotate(22.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 144.71,
    y1: 80.19,
    x2: 167.19,
    y2: 80.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 15.31,
    y1: 217.59,
    x2: 37.78,
    y2: 217.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 144.71,
    y1: 51.89,
    x2: 167.19,
    y2: 51.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 144.71,
    y1: 23.59,
    x2: 167.19,
    y2: 23.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 173.02,
    y1: 23.59,
    x2: 195.49,
    y2: 23.59,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 98.68,
    cy: 90.05,
    r: 8.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m161.04,166.35c-4.68,0-8.47-3.79-8.47-8.47s3.79-8.47,8.47-8.47,8.47,3.79,8.47,8.47-3.79,8.47-8.47,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m84.74,220.24c0-4.68,3.79-8.47,8.47-8.47s8.47,3.79,8.47,8.47-3.79,8.47-8.47,8.47-8.47-3.79-8.47-8.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 30.85,
    cy: 152.41,
    r: 8.47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m149.9,117.04c-3.31,3.31-8.67,3.31-11.98,0-3.31-3.31-3.31-8.67,0-11.98,3.31-3.31,8.67-3.31,11.98,0,3.31,3.31,3.31,8.67,0,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m134.05,209.1c-3.31-3.31-3.31-8.67,0-11.98,3.31-3.31,8.67-3.31,11.98,0,3.31,3.31,3.31,8.67,0,11.98-3.31,3.31-8.67,3.31-11.98,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.99,193.25c3.31-3.31,8.67-3.31,11.98,0,3.31,3.31,3.31,8.67,0,11.98-3.31,3.31-8.67,3.31-11.97,0-3.31-3.31-3.31-8.67,0-11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m57.84,101.19c3.31,3.31,3.31,8.67,0,11.98-3.31,3.31-8.67,3.31-11.98,0-3.31-3.31-3.31-8.67,0-11.98,3.31-3.31,8.67-3.31,11.97,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m160.45,140.92c-4.33,1.77-9.27-.31-11.04-4.64-1.77-4.33.31-9.27,4.64-11.04,4.33-1.77,9.27.31,11.04,4.64,1.77,4.33-.31,9.27-4.64,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m110.18,219.65c-1.77-4.33.31-9.27,4.64-11.04,4.33-1.77,9.27.31,11.04,4.64,1.77,4.33-.31,9.27-4.64,11.04-4.33,1.77-9.27-.31-11.04-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.44,169.37c4.33-1.77,9.27.31,11.04,4.64,1.77,4.33-.31,9.27-4.64,11.04-4.33,1.77-9.27-.31-11.04-4.64-1.77-4.33.31-9.27,4.64-11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.72,90.64c1.77,4.33-.31,9.27-4.64,11.04-4.33,1.77-9.27-.31-11.04-4.64-1.77-4.33.31-9.27,4.64-11.04,4.33-1.77,9.27.31,11.04,4.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m151.99,190.12c-4.33-1.77-6.41-6.71-4.64-11.04,1.77-4.33,6.71-6.41,11.04-4.64,4.33,1.77,6.41,6.71,4.64,11.04-1.77,4.33-6.71,6.41-11.04,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m60.97,211.18c1.77-4.33,6.71-6.41,11.04-4.64,4.33,1.77,6.41,6.71,4.64,11.04-1.77,4.33-6.71,6.41-11.04,4.64-4.33-1.77-6.41-6.71-4.64-11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.91,120.17c4.33,1.77,6.41,6.71,4.64,11.04-1.77,4.33-6.71,6.41-11.04,4.64-4.33-1.77-6.41-6.71-4.64-11.04,1.77-4.33,6.71-6.41,11.04-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m130.92,99.11c-1.77,4.33-6.71,6.41-11.04,4.64-4.33-1.77-6.41-6.71-4.64-11.04,1.77-4.33,6.71-6.41,11.04-4.64,4.33,1.77,6.41,6.71,4.64,11.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m167.19,80.19c0,6.21-5.03,11.24-11.24,11.24s-11.24-5.03-11.24-11.24,5.03-11.24,11.24-11.24,11.24,5.03,11.24,11.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 26.55,
    cy: 217.59,
    r: 11.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.19,51.89c0,6.21-5.03,11.24-11.24,11.24s-11.24-5.03-11.24-11.24,5.03-11.24,11.24-11.24,11.24,5.03,11.24,11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m167.19,23.59c0,6.2-5.03,11.24-11.24,11.24s-11.24-5.03-11.24-11.24,5.03-11.24,11.24-11.24,11.24,5.03,11.24,11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m195.49,23.59c0,6.2-5.03,11.24-11.24,11.24s-11.24-5.03-11.24-11.24,5.03-11.24,11.24-11.24,11.24,5.03,11.24,11.24Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "243.32 189.09 245.08 189.09 241.63 204.47 239.45 204.47 236.07 189.09 237.8 189.09 240.56 202.02 240.59 202.02 243.32 189.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m258.43,188.8c4.44,0,4.67,5.07,4.67,7.91,0,2.03.14,7.91-4.67,7.91s-4.68-5.75-4.68-7.91c0-6.37,2.12-7.91,4.68-7.91m3.09,7.91c0-1.4.21-6.59-3.09-6.59s-3.09,5.7-3.09,6.59c0,1.73-.09,6.58,3.09,6.58,1.58,0,3.09-1.06,3.09-6.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.73 189.09 280.49 189.09 276.6 197.89 276.6 204.33 275.01 204.33 275.01 197.89 271.12 189.09 272.87 189.09 275.81 195.99 278.73 189.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m299.38,204.33h-1.71l-1.36-4.48h-4.63l-1.35,4.48h-1.71l5.37-16.5,5.39,16.5Zm-7.32-5.82h3.87l-1.94-6.15-1.93,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m311.46,198.04v-1.33h5.19v7.91h-1.59v-1.49c-.79.96-1.95,1.49-3.2,1.49s-4.59-.21-4.59-7.58c0-6.03,1.83-8.25,4.8-8.25,2.58,0,3.79,1.81,3.83,4.19h-1.58c.12-1.39-.55-2.86-2.16-2.86-3.17,0-3.3,4.42-3.3,6.69,0,2.11.11,6.47,3.09,6.47,1.48,0,3.11-1.19,3.11-4.23v-1.02h-3.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "334 190.43 327.69 190.43 327.69 195.84 332.23 195.84 332.23 197.17 327.69 197.17 327.69 202.99 334.15 202.99 334.15 204.33 326.1 204.33 326.1 189.09 334 189.09 334 190.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m350.59,191.84c-.92-.82-1.98-1.71-3.29-1.71s-2.45.94-2.45,2.34c0,.8.14,1.52,2.19,2.77l1.21.74c2.79,1.72,3.56,2.52,3.56,4.3,0,2.72-1.83,4.36-4.49,4.36-1.97,0-3.42-.95-4.61-2.48l1.23-.98c.73,1.19,1.92,2.12,3.38,2.12,1.6,0,2.9-1.19,2.9-2.82,0-1.23-.09-1.65-2.77-3.26l-1.37-.82c-1.5-.88-2.81-1.93-2.81-3.83,0-2.38,1.81-3.76,4.1-3.76,1.59,0,3.05.84,4.19,1.9l-.96,1.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m216.94,160.52c-2.56,0-4.8-.44-6.72-1.31s-3.4-2.09-4.45-3.65c-1.05-1.56-1.57-3.32-1.57-5.28s.46-3.65,1.38-5.19c.92-1.54,2.42-2.75,4.51-3.65,2.09-.9,4.87-1.34,8.32-1.34h9.92v5.31h-9.35c-2.73,0-4.57.44-5.51,1.31-.94.88-1.41,1.95-1.41,3.23,0,1.45.58,2.6,1.73,3.46,1.15.85,2.75,1.28,4.8,1.28s3.72-.45,5.28-1.34c1.56-.9,2.68-2.22,3.36-3.97l1.34,4.8c-.77,2.01-2.15,3.56-4.13,4.67-1.98,1.11-4.49,1.67-7.52,1.67Zm10.76-.45v-6.91l-.45-1.47v-12.1c0-2.35-.7-4.17-2.11-5.47-1.41-1.3-3.54-1.95-6.4-1.95-1.92,0-3.81.3-5.67.9-1.86.6-3.42,1.43-4.71,2.5l-3.14-5.83c1.83-1.41,4.02-2.46,6.56-3.17,2.54-.7,5.17-1.06,7.91-1.06,4.95,0,8.78,1.18,11.49,3.55,2.71,2.37,4.07,6.03,4.07,10.98v20.04h-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m245.5,160.07v-47.5h8v21.26l-.64,9.09.26,9.09v8.07h-7.62Zm18.95.45c-2.9,0-5.48-.64-7.75-1.92-2.26-1.28-4.04-3.21-5.35-5.79-1.3-2.58-1.95-5.86-1.95-9.83s.67-7.3,2.02-9.86c1.34-2.56,3.16-4.47,5.44-5.73,2.28-1.26,4.81-1.89,7.59-1.89,3.37,0,6.35.73,8.93,2.18,2.58,1.45,4.63,3.48,6.15,6.08,1.51,2.6,2.27,5.68,2.27,9.22s-.76,6.62-2.27,9.22c-1.52,2.6-3.56,4.64-6.15,6.11-2.58,1.47-5.56,2.21-8.93,2.21Zm-.9-6.85c1.92,0,3.64-.43,5.15-1.28,1.51-.85,2.72-2.09,3.62-3.71s1.34-3.52,1.34-5.7-.45-4.13-1.34-5.73-2.1-2.83-3.62-3.68c-1.52-.85-3.23-1.28-5.15-1.28s-3.65.43-5.19,1.28c-1.54.85-2.75,2.08-3.65,3.68s-1.34,3.51-1.34,5.73.45,4.08,1.34,5.7,2.11,2.86,3.65,3.71c1.54.85,3.27,1.28,5.19,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m289.42,160.07v-47.5h8v47.5h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m323.99,160.52c-3.8,0-7.12-.76-9.96-2.27-2.84-1.51-5.04-3.6-6.59-6.24-1.56-2.65-2.34-5.66-2.34-9.03s.76-6.43,2.27-9.06c1.51-2.62,3.61-4.68,6.27-6.18,2.67-1.49,5.71-2.24,9.12-2.24s6.3.73,8.9,2.18c2.6,1.45,4.65,3.5,6.15,6.15,1.49,2.65,2.24,5.76,2.24,9.35,0,.34-.01.73-.03,1.15-.02.43-.05.83-.1,1.22h-28.49v-5.31h24.26l-3.14,1.66c.04-1.96-.36-3.69-1.22-5.19-.85-1.49-2.02-2.67-3.49-3.52-1.47-.85-3.17-1.28-5.09-1.28s-3.68.43-5.15,1.28c-1.47.85-2.62,2.04-3.46,3.55-.83,1.52-1.25,3.3-1.25,5.35v1.28c0,2.05.47,3.86,1.41,5.44.94,1.58,2.26,2.8,3.97,3.65,1.71.85,3.67,1.28,5.89,1.28,1.92,0,3.65-.3,5.19-.9s2.9-1.54,4.1-2.82l4.29,4.93c-1.54,1.79-3.47,3.17-5.79,4.13-2.33.96-4.98,1.44-7.97,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m362.21,160.52c-3.29,0-6.24-.74-8.87-2.21s-4.68-3.51-6.18-6.11c-1.5-2.6-2.24-5.68-2.24-9.22s.75-6.62,2.24-9.22c1.49-2.6,3.55-4.63,6.18-6.08,2.62-1.45,5.58-2.18,8.87-2.18,2.86,0,5.42.63,7.68,1.89,2.26,1.26,4.05,3.17,5.38,5.73,1.32,2.56,1.98,5.85,1.98,9.86s-.64,7.25-1.92,9.83c-1.28,2.58-3.05,4.51-5.31,5.79-2.26,1.28-4.87,1.92-7.81,1.92Zm.96-6.85c1.92,0,3.64-.43,5.15-1.28,1.51-.85,2.73-2.09,3.65-3.71.92-1.62,1.38-3.52,1.38-5.7s-.46-4.13-1.38-5.73c-.92-1.6-2.13-2.83-3.65-3.68-1.52-.85-3.23-1.28-5.15-1.28s-3.64.43-5.15,1.28c-1.52.85-2.73,2.08-3.65,3.68s-1.38,3.51-1.38,5.73.46,4.08,1.38,5.7,2.13,2.86,3.65,3.71c1.51.85,3.23,1.28,5.15,1.28Zm10.37,6.4v-8.07l.32-9.09-.64-9.09v-21.26h7.94v47.5h-7.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbledLogoH);
export default __webpack_public_path__ + "static/media/AbledLogoH.89510f4c88ef9ba1fc85292ff33e4ae7.svg";
export { ForwardRef as ReactComponent };